import { render, staticRenderFns } from "./confirmFlow.vue?vue&type=template&id=f1d030a4&scoped=true&lang=pug&"
import script from "./confirmFlow.vue?vue&type=script&lang=js&"
export * from "./confirmFlow.vue?vue&type=script&lang=js&"
import style0 from "./confirmFlow.vue?vue&type=style&index=0&id=f1d030a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d030a4",
  null
  
)

export default component.exports